import axios from 'axios';

export const migrationsApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/migrations`,
    headers: {
        'Content-Type': 'application/json'
    }
})